<template src="./template.html" ></template>

<script>
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
import MyNumber from '../../components/MyNumber.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MyFloat from '../../components/MyFloat.vue'
import MygPersons from './MygPersons.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'person-items',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      model: {
        type: 'person',
        gender: 'true',
        group_id: null,
        init: {
          items: [{
            type: 'incalculable',
            price: 0
          }, {
            type: 'incalculable',
            lending_value: 0
          }]
        }
      },
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
      gtZeroRules: [
        v => !!v || 'فیلد اجباری',
        v => (v && this.rmCamma(v) >= 0) || 'فیلد اجباری'
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      // console.log(this.model);
    }
  },
  methods: {
    async onSave() {
      //
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        // console.log(res);
        if (res && (res.insert || res.update)) {
          this.alert = true
        }
      }
    },
    onChangeType(e) {
      if (e === 'person') {
        this.model.gender = 'true'
      } else if (e === 'other') {
        this.model.last_name = null
        this.model.alias = null
        this.model.gender = 'false'
      }
    },
    onChangePrice(e) {
      if (e === 'incalculable') {
        this.model.init.items[0].price = 0
      }
    },
    onChangeLendingValue(e) {
      if (e === 'incalculable') {
        this.model.init.items[1].lending_value = 0
      }
    },
  },
  components: {
    MyAlert,
    MyListButtons,
    MyNumber,
    MyCurrency,
    MyFloat,
    MygPersons,
    MyComment,
  },
}
</script>
<style lang="scss">
</style>
